import { Link } from "@tanstack/react-router";
import { ArrowUpRight } from "lucide-react";
import type { ReactNode } from "react";

import { inkButton, primaryButton, smallButton } from "./section";
import { cn } from "@/lib/utils";

type GoLinkProps = {
  children: ReactNode;
  /** An app route, or an in-page anchor such as `#times`. */
  to: string;
  /** Element id to scroll to on the target route. */
  hash?: string;
  /** `ink` is for a link that sits on a solid primary card. */
  tone?: "primary" | "ink";
  size?: "default" | "small";
  className?: string;
};

/** The site's call to action: a solid pill with an arrow that tips up on hover. */
export const GoLink = ({ children, to, hash, tone = "primary", size = "default", className }: GoLinkProps) => {
  const classes = cn("group", tone === "ink" ? inkButton : primaryButton, size === "small" && smallButton, className);
  const content = (
    <>
      {children}
      {size === "small" ? null : (
        <ArrowUpRight aria-hidden className="size-4 transition-transform duration-200 group-hover:rotate-45" />
      )}
    </>
  );

  if (to.startsWith("#")) {
    return (
      <a href={to} className={classes}>
        {content}
      </a>
    );
  }
  return (
    <Link to={to} hash={hash} className={classes}>
      {content}
    </Link>
  );
};
